import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MaskText, Reveal, SectionLabel } from './ui/Reveal';
import { process } from '../data/site';
import { usePrefersReducedMotion } from '../hooks/useMedia';

/** Scroll-driven process timeline with a progress rail. */
export function Process() {
  const ref = useRef<HTMLDivElement>(null);
  const reduced = usePrefersReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start 65%', 'end 85%']
  });
  const height = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
  return <section className="bg-surface2 py-20 sm:py-28" aria-label="Our process" data-id="element-432" data-mp="1fo79o3orfsc9">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-433" data-mp="1kffk931ttjr0">
        <div className="grid gap-6 lg:grid-cols-[1fr_1fr] lg:items-end" data-id="element-434" data-mp="1kgqof3z6otin">
          <div data-id="element-435" data-mp="mza3gyxtplzv">
            <SectionLabel data-id="element-436" data-mp="mzrwznt3pm43">Process</SectionLabel>
            <h2 className="mt-5 font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tightest sm:text-6xl" data-id="element-437" data-mp="ryv0v4xchmah">
              <MaskText text="How the work|gets made" data-id="element-438" data-mp="19k68hby7mrpb" />
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-muted sm:text-lg" data-id="element-439" data-mp="15jdz8ipc8mt1">
            A clear, repeatable process — so you always know where the project is and what happens
            next.
          </p>
        </div>

        <div ref={ref} className="relative mt-14 pl-8 sm:pl-14" data-id="element-440" data-mp="vtb70kq1jcvr">
          <div className="absolute left-0 top-0 h-full w-px bg-line" aria-hidden="true" data-id="element-441" data-mp="quzxkb3nr4e2">
            <motion.div className="w-px bg-brand" style={reduced ? {
            height: '100%'
          } : {
            height
          }} data-id="element-442" data-mp="lv5728nsogtj" />
          </div>

          <ol data-id="element-443" data-mp="hw5srxg6b7pf">
            {process.map((item, index) => <Reveal as="li" key={item.step} delay={index * 0.04} data-id="element-444" data-mp="cw0a36rvsvjh" data-mpi={index}>
                <div className="group relative grid gap-3 border-b border-line py-8 sm:grid-cols-[8rem_1fr] sm:gap-8" data-id="element-445" data-mp="2c7syif0lsskl">
                  <span className="absolute -left-8 top-[3.05rem] h-1.5 w-1.5 rounded-full bg-brand sm:-left-14" aria-hidden="true" data-id="element-446" data-mp="278q4rqq2q8rx" />
                  <span className="label text-brand" data-id="element-447" data-mp="2v4uushu8s4a2">{item.step} — {item.title}</span>
                  <div data-id="element-448" data-mp="2hd6jggrthju5">
                    <h3 className="font-display text-2xl font-bold uppercase leading-none tracking-tightest transition-colors duration-300 group-hover:text-brand sm:text-4xl" data-id="element-449" data-mp="2hdzg2ox2asyk">
                      {item.title}
                    </h3>
                    <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-450" data-mp="3a2dcj08i5h80">
                      {item.description}
                    </p>
                  </div>
                </div>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}